import React from 'react'
import './tableNormas.css'

const TableDespacho = () => {
    return (
        <section style={{ width: '100%', marginTop: '40px', marginBottom: '40px' }}>
            <table>
                <tr>
                    <td>
                        <div className="th">INGRESO Y SALIDA DE MERCANCÍAS Y MEDIOS DE TRANSPORTES</div>
                        <ul className="td">
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/manifiestos/procGeneral/despa-pg.09.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Manifiesto de Carga
                                </a>
                            </li>
                        </ul>

                        <div className="th">RÉGIMENES DE IMPORTACIÓN</div>
                        <ul className="td">
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/importacion/importac/procGeneral/despa-pg.01.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Importación para el Consumo
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/importacion/adTemporalR/procGeneral/despa-pg.04.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Admisión temporal para reexportación en el mismo estado
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/importacion/reimportac/procGeneral/despa-pg.26.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Reimportación en el mismo estado
                                </a>
                            </li>
                        </ul>

                        <div className="th">RÉGIMENES DE EXPORTACIÓN</div>
                        <ul className="td">
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/exportacion/exportac/procGeneral/despa-pg.02.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Exportación Definitiva
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/exportacion/exTemporal/procGeneral/despa-pg.05.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Exportación temporal para reimportación en el mismo estado
                                </a>
                            </li>
                        </ul>

                        <div className="th">RÉGIMENES DE PERFECCIONAMIENTO</div>
                        <ul className="td">
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/perfeccionam/adTemporal/procGeneral/despa-pg.06.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Admisión temporal para perfeccionamiento activo
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/exportacion/exTemporal/procGeneral/despa-pg.05.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Exportación temporal para perfeccionamiento pasivo
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/perfeccionam/drawback/procGeneral/despa-pg.07.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Restitución Simplificada de Derechos Arancelarios
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/perfeccionam/reposMercan/procGeneral/despa-pg.10.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Reposición de mercancías con franquicia arancelaria
                                </a>
                            </li>
                        </ul>

                        <div className="th">RÉGIMEN DE DEPÓSITO ADUANERO</div>
                        <ul className="td">
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/deposito/deposito/procGeneral/despa-pg.03.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Depósito Aduanero
                                </a>
                            </li>
                        </ul>
                    </td>

                    <td>
                        <div className="th">RÉGIMENES DE TRÁNSITO</div>
                        <ul className="td">
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/transito/transito/procGeneral/despa-pg.08.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Tránsito Aduanero
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/transito/transbordo/procGeneral/despa-pg.11.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Transbordo
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/transitoInt/procGeneral/despa-pg.27.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Tránsito Aduanero Internacional de Mercancías CAN-ALADI
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/transito/reembarque/procGeneral/despa-pg.12.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Reembarque
                                </a>
                            </li>
                        </ul>

                        <div className="th">REGÍMENES ADUANEROS ESPECIALES O DE EXCEPCIÓN</div>
                        <ul className="td">
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/consecPostal/procGeneral/despa-pg.13.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Envíos o Paquetes Postales transportados por el Servicio Postal
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/ferias/procGeneral/despa-pg.15.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Ferias o Exposiciones Internacionales
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/vehiculos/procGeneral/despa-pg.16.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Vehículos para Turismo
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/duttyFree/procGeneral/despa-pg.17.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Duty Free
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/ranchoNave/procGeneral/despa-pg.18.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Rancho de Nave
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/materUsoAero/procGeneral/despa-pg.19.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Material para Uso Aeronáutico
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/materGuerra/procGeneral/despa-pg.20.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Material de Guerra
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/contenedores/procGeneral/despa-pg.21.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Contenedores
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/mensajeria/procGeneral/despa-pg.25.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Servicio de Mensajería Internacional
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/especiales/envioEntRap/procGeneral/despa-pg.28.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Envíos de Entrega rápida
                                </a>
                            </li>
                        </ul>

                        <div className="th">OTROS</div>
                        <ul className="td">
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/ceticos/procGeneral/despa-pg.22.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    ZED (antes CETICOS)
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/procAsociados/index.html" target="_blank" style={{ textDecoration: "underline" }}>
                                    Procedimientos Aduaneros
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/procAsociados/despa-pe.00.22.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Cabotaje Marítimo de Carga con Recorrido por Puertos Internacionales
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/zofratacna/procGeneral/despa-pg.23.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    ZOFRATACNA
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/circulares/fdetalle.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Circulares por Años
                                </a>
                            </li>
                        </ul>

                        <div className="th">Autorización y Certificación de Operadores</div>
                        <ul className="td">
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/operadores/procGeneral/despa-pg.24.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Autorización y Categorización de Operadores de Comercio Exterior
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/operadores/certifiOperador/procGeneral/despa-pg.29.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Certificación del Operador Económico Autorizado
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/resoluciones/fdetalle.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Resoluciones por Año
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/tripulantes/despa-pe.14.01.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Computadoras Portátil-CIAS Aéreas
                                </a>
                            </li>
                            <li>
                                <a href="https://www.sunat.gob.pe/legislacion/procedim/despacho/procedimientosDerogados/index.htm" target="_blank" style={{ textDecoration: "underline" }}>
                                    Procedimientos Derogados
                                </a>
                            </li>
                        </ul>
                    </td>
                </tr>
            </table>
        </section>
    )
}

export default TableDespacho
